import { useTranslation } from 'react-i18next'
import { useRecoilValue } from 'recoil'
import { atomPolicy } from 'src/storage'
import { toDate } from 'src/utils'

export const useInfoSection = () => {
  const { t } = useTranslation()
  const policy = useRecoilValue(atomPolicy)
  const fills = {
    startDate: toDate(policy?.dataInizio) || '',
    endDate: toDate(policy?.dataFine) || '',
  }

  return {
    t,
    fills,
  }
}
